<template>
  <Listbox as="div" v-model="selectedValue" ref="listbox" v-slot="{ open }">
    <ListboxLabel class="block text-sm font-medium text-brand-gray-900">
      {{ label }}
    </ListboxLabel>
    <div class="relative mt-1">
      <ListboxButton
        class="relative w-full py-3 pl-3 pr-10 text-left bg-white border rounded-md shadow-sm cursor-default border-brand-gray-500 focus:border-brand-blue focus:outline-none focus:ring-4 ring-brand-blue ring-opacity-25 sm:text-sm"
        :class="{'border-brand-red ring-brand-red ring-4 bg-red-50': hasError && !open}"
      >
        <span class="block truncate">{{ selectedValue.name }}</span>
        <span
          class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none "
        >
          <SelectorIcon class="w-5 h-5 text-gray-400" aria-hidden="true" />
        </span>
      </ListboxButton>

      <transition
        leave-active-class="transition duration-100 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <ListboxOptions
          class="absolute z-10 w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
        >
          <ListboxOption
            as="template"
            v-for="item in data"
            :key="item.id"
            :value="item"
            v-slot="{ active, selected }"
          >
            <li
              @click="clicked(item)"
              :class="[
                active ? 'text-white bg-brand-blue' : 'text-gray-900',
                'cursor-default select-none relative py-2 pl-3 pr-9',
              ]"
            >
              <span
                :class="[
                  selected ? 'font-semibold' : 'font-normal',
                  'block truncate',
                ]"
              >
                {{ item.name }}
              </span>

              <span
                v-if="selected"
                :class="[
                  active ? 'text-white' : 'text-brand-blue',
                  'absolute inset-y-0 right-0 flex items-center pr-4',
                ]"
              >
                <CheckIcon class="w-5 h-5" aria-hidden="true" />
              </span>
            </li>
          </ListboxOption>
        </ListboxOptions>
      </transition>
    </div>
    <div class="mt-1" v-if="hasError">
        <p v-for="(error, i) in errors" :key="i" class="text-sm text-left text-red-600 error">{{ error }}</p>
    </div>
  </Listbox>

</template>

<script>
import {
  Listbox,
  ListboxButton,
  ListboxLabel,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/vue";
import { CheckIcon, SelectorIcon } from "@heroicons/vue/solid";

export default {
  components: {
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    CheckIcon,
    SelectorIcon,
  },

  emits: ["update:modelValue"],

  props: {
    data: {
      type: Array,
    },

    label: String,

    modelValue: Object,

    errors: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    clicked(item) {
      this.$emit("update:modelValue", item);
    },

  },

  computed: {
    hasError() {
        return this.errors.length > 0;
    },

    selectedValue: {
      get() {
        return this.modelValue || this.data[0];
      },
    },
  },
};
</script>